/**
 * CUSTOM: Fødselssten-vælger. Markup: snippets/custom-birthstone-selector.liquid
 * Flyttet fra inline <script> i snippets/block-birthstone-only.liquid (8/10 2026).
 * Logik uændret; debug-logning i kundens konsol fjernet (14 console.log).
 */
document.addEventListener('DOMContentLoaded', function() {

  const birthstoneDropdownToggle = document.querySelector('.birthstone-dropdown-toggle');
  const birthstoneDropdownContent = document.querySelector('.birthstone-dropdown-content');
  const birthstoneOptions = document.querySelectorAll('.birthstone-option');
  const selectedBirthstoneText = document.querySelector('.selected-birthstone-text');
  const errorDiv = document.querySelector('.birthstone-only-error');
  const addToCartBtn = document.querySelector('[data-add-to-cart], button[name="add"], .product-form__submit');

  // Find den korrekte formular
  const addToCartForm = document.querySelector('.product-single__form') || 
                       document.querySelector('form[action*="/cart/add"]') || 
                       document.querySelector('[data-add-to-cart-form]');


  let selectedBirthstone = null;

  // Funktion til at finde eller oprette hidden inputs
  function ensureHiddenInputs() {
    if (!addToCartForm) {
      console.error('Kunne ikke finde produktformular!');
      return { birthstoneInput: null, monthInput: null };
    }

    // Tjek for eksisterende inputs (både med og uden -property)
    let birthstoneInput = document.querySelector('input[name="properties[Fødselssten]"]');
    let monthInput = document.querySelector('input[name="properties[Måned]"]');

    // Hvis de ikke findes, opret dem
    if (!birthstoneInput) {
      birthstoneInput = document.createElement('input');
      birthstoneInput.type = 'hidden';
      birthstoneInput.name = 'properties[Fødselssten]';
      birthstoneInput.id = 'selected-birthstone-property';
      birthstoneInput.value = '';
      addToCartForm.appendChild(birthstoneInput);
    }

    if (!monthInput) {
      monthInput = document.createElement('input');
      monthInput.type = 'hidden';
      monthInput.name = 'properties[Måned]';
      monthInput.id = 'selected-month-property';
      monthInput.value = '';
      addToCartForm.appendChild(monthInput);
    }

    // Tilføj også et marker input for birthstone_only
    let markerInput = document.querySelector('input[name="properties[_birthstone_only_product]"]');
    if (!markerInput) {
      markerInput = document.createElement('input');
      markerInput.type = 'hidden';
      markerInput.name = 'properties[_birthstone_only_product]';
      markerInput.value = 'true';
      addToCartForm.appendChild(markerInput);
    }


    return { birthstoneInput, monthInput };
  }

  // Opret/find inputs med det samme
  let { birthstoneInput: birthstonePropertyInput, monthInput: monthPropertyInput } = ensureHiddenInputs();

  // Toggle birthstone dropdown
  if (birthstoneDropdownToggle) {
    birthstoneDropdownToggle.addEventListener('click', function(e) {
      e.preventDefault();
      const isOpen = birthstoneDropdownContent.style.display === 'block';
      birthstoneDropdownContent.style.display = isOpen ? 'none' : 'block';
      this.querySelector('svg').style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  }

  // Birthstone selection
  birthstoneOptions.forEach(option => {
    option.addEventListener('click', function(e) {
      e.preventDefault();

      // Clear previous selection
      birthstoneOptions.forEach(opt => {
        opt.style.borderColor = '#ddd';
        opt.style.background = 'white';
      });

      // Mark as selected
      this.style.borderColor = '#333';
      this.style.background = '#f9f9f9';

      selectedBirthstone = this.dataset.stone;
      const selectedMonth = this.dataset.month;


      // Get the image from the clicked option
      const selectedImage = this.querySelector('img');
      const imageHtml = selectedImage ? selectedImage.outerHTML : '<div style="width: 30px; height: 30px; border-radius: 50%; background: #f0f0f0; display: inline-block; vertical-align: middle; margin-right: 8px;"></div>';

      // Update the button with image and text
      selectedBirthstoneText.innerHTML = imageHtml + `<span style="vertical-align: middle;">${selectedMonth} - ${selectedBirthstone}</span>`;
      selectedBirthstoneText.style.display = 'flex';
      selectedBirthstoneText.style.alignItems = 'center';

      // Style the image in the button
      const buttonImage = selectedBirthstoneText.querySelector('img');
      if (buttonImage) {
        buttonImage.style.width = '30px';
        buttonImage.style.height = '30px';
        buttonImage.style.borderRadius = '50%';
        buttonImage.style.marginRight = '8px';
        buttonImage.style.objectFit = 'contain';
      }

      // Sørg for at inputs eksisterer
      const inputs = ensureHiddenInputs();
      birthstonePropertyInput = inputs.birthstoneInput;
      monthPropertyInput = inputs.monthInput;

      // Update hidden inputs for line item properties
      if (birthstonePropertyInput) {
        birthstonePropertyInput.value = selectedBirthstone;
      }
      if (monthPropertyInput) {
        monthPropertyInput.value = selectedMonth;
      }

      // Trigger change event for any listeners
      if (birthstonePropertyInput) {
        birthstonePropertyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (monthPropertyInput) {
        monthPropertyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      errorDiv.style.display = 'none';

      // Close dropdown
      birthstoneDropdownContent.style.display = 'none';
      birthstoneDropdownToggle.querySelector('svg').style.transform = 'rotate(0deg)';

    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.birthstone-only-picker')) {
      birthstoneDropdownContent.style.display = 'none';
      if (birthstoneDropdownToggle) {
        birthstoneDropdownToggle.querySelector('svg').style.transform = 'rotate(0deg)';
      }
    }
  });

  // Validate on add to cart
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      if (!selectedBirthstone) {
        e.preventDefault();
        e.stopPropagation();
        errorDiv.style.display = 'block';
        birthstoneDropdownToggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
        birthstoneDropdownToggle.focus();


        return false;
      } else {
        // Sidste tjek: sørg for at felterne findes i formularen
        ensureHiddenInputs();
      }
    });
  }

  // Also validate on form submit
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      if (!selectedBirthstone) {
        e.preventDefault();
        e.stopPropagation();
        errorDiv.style.display = 'block';
        birthstoneDropdownToggle.scrollIntoView({ behavior: 'smooth', block: 'center' });
        birthstoneDropdownToggle.focus();


        return false;
      }
    });
  }

});
